module.exports = {
  locales: ["fr", "en"],
  defaultLocale: "fr",
  pages: {
    "*": ["common"],
    "rgx:^/applications|^/admin|^/organizations|^/central": ["sites"],
    "rgx:^/domains|^/admin|^/applications": ["domains"],
  },
};
